export const defaultInputRules = {
  required: () => ({ value: true, message: 'Esse campo é obrigatório' }),
  maxLength: ({ value }) => ({ value, message: `Esse campo aceita no máximo ${value} caracteres` }),
  minLength: ({ value }) => ({ value, message: `Esse campo aceita no mínimo ${value} caracteres` }),
  pattern: ({ value, message }) => ({ value, message: message ?? 'Campo no formato inválido' }),
}
